export const userGroupsKeys = {
  all: ['userGroups'] as const,
  group: (id: string) => [...userGroupsKeys.all, id] as const,
};
